@if (environment.testData) {
  <div class="">
    <h2>Test data</h2>
    <ng-content></ng-content>
  </div>
}
